import React from "react";

const ProgressBar = ({
  color = "blue",
  percent,
  displayText = true,
  width,
  barLength,
  gap = 12,
}) => {
  function renderText() {
    if (displayText) {
      return <div className="new_progress_bar__value">{percent}%</div>;
    }
  }

  return (
    <div className="new_progress_bar__wrapper" style={{ width: width, gap: gap }}>
      <div className="new_progress_bar__container" style={{ width: barLength }}>
        <div
          className={`new_progress_bar__fill new_progress_bar__fill--${color}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      {renderText()}
    </div>
  );
};

export default ProgressBar;
